import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import EditTable from '../EditTable';
import { LockFill, UnlockFill } from 'react-bootstrap-icons';

class Categories extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			categories: [],
			editable: false,
			editorsOpen: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadCategories();
	}

	loadCategories() {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/Search',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'SHOP_PART_CATEGORY_VW',
				search: { Attribute: 'DELETE_FLAG', Operator: 'is null' },
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				for (var i = 0; i < data.Data.length; i++) {
					data.Data[i].id = i;
				}
				self.mergeState({ categories: data.Data });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		

	onChange(accessor, value) {
		var newState = this.copyObject(this.state);
		this.setByAccessor(newState, accessor, value);
		newState.renderKey = this.state.renderKey + 1;

		// if this accessor represents an EditTable
		if (['categories'].includes(accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.setState(newState);
	}

	onSubmit(event) {
		var self = this;

		if (this.state.editorsOpen.includes('categories')) {
			this.showAlert('Editor Open', 'Please close the category editor before saving.');
		} else {
			var categories = this.copyObject(this.state.categories);

			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Jobtrack/UpdateCategories',
				overlay: true,
				data: {
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					categories: {
						categories: categories
					}
				}
			}).done(function (data) {
				if (data.Success) {
					self.props.parent.showConfirmation(() => {
						return (<>
							Categories successfully updated.
						</>);
					});				
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Material Parts Categories&nbsp;&nbsp;
							{this.state.editable ? 
							  <UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
								onClick={() => this.mergeState({ editable: false })} /> : 
							  <LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
								onClick={() => this.mergeState({ editable: true })} />}
						</div>
						<div style={{ marginBottom: '10px' }}>
							Material parts are divided in categories or key words for easier search and retrieval
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
						  data={this.state.categories} editable={this.state.editable} tableColumns={catTableColumns} 
						  editColumns={catEditColumns} tableName='Jobtrack_Categories' newRecord={emptyCategory}
						  onEdit={(editorIsOpen, idx) => this.onEdit('categories', editorIsOpen, idx)}
						  onChange={(data, callback) => this.onChange('categories', data)} />
					  </Col>
					</Row>
					<Row>
					  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
						{this.state.editable && <Button id="save" variant="warning" type="button" className="float-end" onClick={() => this.onSubmit()}>Save</Button>}
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const emptyCategory = {
	id: null,
	CATEGORY_ID: null,
	CATEGORY_NAME: '',
	COMMENTS: '',
	CREATED_BY: '',
	DATE_CREATED: null,
	DATE_MODIF: null,
	MODIF_BY: '',
	DELETE_FLAG: '',
	UPDATED: ''
};

const catTableColumns = [
	{ Header: 'ID', accessor: 'CATEGORY_ID', width: 60 },
	{ Header: 'Name', accessor: 'CATEGORY_NAME', width: 200 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 300 },
	{ Header: 'Last Update', accessor: 'UPDATED', width: 250 },
];

const catEditColumns = [
	{ Header: 'ID', accessor: 'CATEGORY_ID', row: 0, col: 0, editable: false },
	{ Header: 'Name', accessor: 'CATEGORY_NAME', row: 0, col: 1, required: true },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 1, col: 0 },
	{ Header: 'Updated', accessor: 'UPDATED', row: 2, col: 1, editable: false } 
];

export default withRouter(Categories);
